var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11837_6237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0801 20.9043L17.6251 24.9043L12.0801 20.9043L6.53508 24.9043L0.0800781 20.9043V0.904297L6.53508 4.9043L12.0801 0.904297L17.6251 4.9043L24.0801 0.904297V20.9043ZM12.5801 7.9043H11.5801V2.4983L7.08008 5.7443V9.9043H6.08008V5.7983L1.08008 2.7003V20.3473L6.08008 23.4463V16.9043H7.08008V23.2783L11.5801 20.0323V14.9043H12.5801V20.0323L17.0801 23.2783V17.9043H18.0801V23.4463L23.0801 20.3473V2.7003L18.0801 5.7983V8.9043H17.0801V5.7443L12.5801 2.4983V7.9043ZM20.7521 14.9203L19.4561 13.6463L20.7291 12.3533L20.0211 11.6513L18.7491 12.9453L17.4551 11.6743L16.7521 12.3763L18.0481 13.6523L16.7751 14.9483L17.4781 15.6513L18.7551 14.3533L20.0501 15.6283L20.7521 14.9203ZM6.65008 14.3143C6.27708 14.3143 5.90908 14.2483 5.55808 14.1193L5.96508 13.0143C6.18608 13.0953 6.41608 13.1363 6.65008 13.1363C6.91008 13.1363 7.16408 13.0863 7.40408 12.9873L7.85208 14.0773C7.46908 14.2343 7.06508 14.3143 6.65008 14.3143ZM4.04908 11.9403C3.51408 11.9403 3.08008 12.3733 3.08008 12.9083C3.08008 13.4423 3.51408 13.8763 4.04908 13.8763C4.58408 13.8763 5.01808 13.4423 5.01808 12.9083C5.01808 12.3733 4.58408 11.9403 4.04908 11.9403ZM15.3201 13.5313L13.6611 12.5863L14.2441 11.5623L15.9041 12.5073L15.3201 13.5313ZM8.86508 13.5113L8.26008 12.5003L9.89808 11.5193L10.5041 12.5293L8.86508 13.5113ZM12.7831 12.1033C12.5401 12.0023 12.2831 11.9503 12.0201 11.9503C11.7891 11.9503 11.5631 11.9903 11.3461 12.0683L10.9441 10.9603C11.2901 10.8353 11.6521 10.7723 12.0201 10.7723C12.4391 10.7723 12.8501 10.8543 13.2361 11.0153L12.7831 12.1033Z",
    fill: "url(#paint0_linear_11837_6237)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11837_6237",
    x1: 24.0801,
    y1: 0.904297,
    x2: -2.16285,
    y2: 22.1314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11837_6237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0800781 0.904297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3a12a048f286e4f84f9ffde32410113c.svg";
export { ForwardRef as ReactComponent };